module.exports = __webpack_public_path__ + "img/c19.dc86a55b.jpg";